import BaseComponent from 'foundation/base-component';
import eventBus from '../../../general/js/event-bus';

export default class LargeHero extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        eventBus.emit('large-hero-init', {
            largeHeroStickyRef: this.refs.sticky
        });
    }
}
